import { render, staticRenderFns } from "./promote-adverts-header.vue?vue&type=template&id=7470da66"
import script from "./promote-adverts-header.vue?vue&type=script&lang=ts"
export * from "./promote-adverts-header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports